<div class="container my-5">
  <div *ngIf="!isDataLoading && sessionInfo">
    <!-- OUTER DASHED RECTANGLE -->
    <div
      class="p-4 rounded-4"
      style="border: 2px dashed #011044; background: #f4f7ff"
    >
      <!-- TOP ROW: LEFT HEADING + RIGHT TIMER -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <!-- LEFT: HEADING + LOGO -->
        <div class="d-flex align-items-center">
          <img
            src="assets/images/nishwiklogoupdated 2.png"
            alt="Logo"
            class="me-2"
            style="width: 50px; height: auto"
          />
          <h3 class="fw-bold mb-0">Welcome to Nishwik!</h3>
        </div>

        <!-- RIGHT: TIMER BOX -->
        <div
          class="px-3 py-2 rounded-3 d-flex align-items-center"
          style="
            background: rgba(255, 255, 255, 0.7);
            backdrop-filter: blur(10px);
            border: 1px solid #ddd;
          "
        >
          <i class="fa-regular fa-clock me-2"></i>
          <span class="fw-semibold">Time Remaining: {{ timerText }}</span>
        </div>
      </div>

      <!-- SUB TEXT -->
      <p class="text-muted fw-semibold">
        Welcome to a smarter way of managing society finances. Together, we’ll
        make patient care effortless and efficient.
      </p>

      <!-- INNER GLASS RECTANGLE -->
      <div
        class="p-3 rounded-4"
        style="
          background: rgba(255, 255, 255, 0.35);
          backdrop-filter: blur(12px) saturate(180%);
          -webkit-backdrop-filter: blur(12px) saturate(180%);
          border: 1px solid rgba(255, 255, 255, 0.5);
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        "
      >
        <h5 class="fw-bold mb-2">
          <i class="fa-regular fa-clipboard me-2"></i>
          Quick Instructions:
        </h5>

        <ul class="mb-0 fw-semibold small">
          <li>Upload the society verification documents available with you</li>
          <li>This page is valid for 24 hours only</li>
          <li>All documents must be clear, legible, and in PDF or image format</li>
          <li>Our team will review the submitted documents after upload</li>
        </ul>
      </div>
    </div>

    <!-- UPLOAD PROGRESS CARD -->
    <div class="bg-white rounded-4 p-4 shadow-sm my-4">
      <!-- Top row -->
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h5 class="fw-bold mb-0">Upload Progress</h5>
        <span class="fw-bold"
          >{{ uploadedCount }}/{{ totalDocuments }} documents</span
        >
      </div>

      <!-- Progress Bar -->
      <div class="progress mb-2" style="height: 10px">
        <div
          class="progress-bar"
          role="progressbar"
          [style.width.%]="uploadPercent"
          style="background-color: #011044"
        ></div>
      </div>

      <!-- Info row -->
      <div class="text-muted small d-flex align-items-center">
        <i class="fa-solid fa-circle-info me-2"></i>
        Please upload the documents available with you.
      </div>
    </div>

    <!-- DOCUMENTS SECTION -->
    <h5 class="fw-bold mb-3">Documents</h5>

    <!-- DOCUMENTS LIST -->
    <ng-container *ngFor="let doc of documents; let i = index">
      <div
        *ngIf="!isDocumentUploadedPresent(doc.name)"
        class="p-3 rounded-4 mb-3 border shadow-sm"
        [ngStyle]="
          doc.uploaded
            ? { 'background-color': '#ECFDF5', 'border-color': '#0BDA51' }
            : { 'background-color': '#ffffff', 'border-color': '#dee2e6' }
        "
      >
        <!-- Top row -->
        <div class="d-flex justify-content-between align-items-center">
          <!-- Left: icon + name + badges + subtext -->
          <div class="d-flex align-items-start">
            <!-- Icon -->
            <i
              *ngIf="!doc.uploaded"
              class="fa-regular fa-file-lines fs-4 me-2 mt-1"
            ></i>
            <i
              *ngIf="doc.uploaded"
              class="fa-solid fa-circle-check fs-4 me-2 mt-1"
              style="color: #00c010"
            ></i>

            <!-- Name + Badges + Subtext -->
            <div class="d-flex align-items-center mb-1">
  <h6 class="fw-bold mb-0 me-2">
    {{ doc.displayName }}
  </h6>
</div>
          </div>
        </div>

        <!-- Upload / Remove Button -->
        <!-- Upload / Remove Button -->
        <div class="mt-3">
          <!-- Upload -->
          <label
            *ngIf="!doc.uploaded && !doc.uploading"
            class="universal-submit-btn"
            style="cursor: pointer"
          >
            <i class="fa-solid fa-upload me-2"></i> Upload Document
            <input
              type="file"
              hidden
              (change)="uploadDocument(i, $event)"
              accept="image/*, application/pdf"
            />
          </label>

          <!-- Loader -->
          <div *ngIf="doc.uploading" class="d-flex align-items-center gap-2">
            <div class="spinner-border spinner-border-sm" role="status"></div>
            <span class="text-muted">Uploading...</span>
          </div>

          <!-- Remove -->
          <button
            *ngIf="doc.uploaded"
            class="universal-close-btn"
            (click)="removeDocument(i)"
          >
            <i class="fa-solid fa-trash me-2"></i> Remove
          </button>
        </div>
      </div>
    </ng-container>

    <!-- <div style="display: flex; align-items: center; justify-content: end;">
      <button class="universal-submit-btn"><i class="bi bi-file-earmark-text-fill"></i> Other Documents</button>
    </div> -->

    <!-- SUBMISSION SECTION -->
    <div class="bg-white rounded-4 p-4 shadow-sm mt-4">
      <!-- Top row: Heading + description on left, button on right -->
      <!-- Top row: Heading + description on left, button on right -->
      <div
        class="d-flex flex-column flex-md-row justify-content-between align-items-start mb-3"
      >
        <!-- Left: Heading + Description -->
        <div class="flex-grow-1 mb-2 mb-md-0">
          <h5 class="fw-bold mb-2 fs-5.5">Ready to Submit?</h5>
          <p class="text-muted mb-0" style="font-weight: 600; font-size: 16px">
            Our team will review your documents within 24-48 hours. We'll
            contact you if any additional information is needed.
          </p>
        </div>

        <!-- Right: Submit Button -->
        <div class="flex-shrink-0">
          <button
  [ngClass]="{
    'universal-submit-btn': isAllRequiredDocumentsUploaded && !isUploading,
    'disabled-submit-btn': !isAllRequiredDocumentsUploaded || isUploading
  }"
  [disabled]="!isAllRequiredDocumentsUploaded || isUploading"
  (click)="bulkUploadAllTheDocuments()"
>
  <i class="fa-solid fa-paper-plane me-2" *ngIf="!isUploading"></i>
  <span *ngIf="!isUploading">Submit Documents</span>
  <div class="small-simple-spinner-container" *ngIf="isUploading">
    <div class="small-simple-spinner"></div>
  </div>
</button>
        </div>
      </div>
    </div>

    <!-- Contact Info & Security Notice -->
    <div class="text-center mt-3">
      <p class="text-muted mb-1">
        Need help? Contact us at
        <a href="mailto:support@nishwikbank.com"
          >support@nishwik.com</a
        >
        or call 9699783260
      </p>
      <p
        class="text-muted small mb-0 d-flex justify-content-center align-items-center gap-2"
      >
        <i class="fa-solid fa-lock"></i>
        Your documents are secure and encrypted. We follow strict data
        protection protocols.
      </p>
    </div>
  </div>

  <div class="simple-spinner-container" *ngIf="isDataLoading && !sessionInfo">
    <div class="simple-spinner"></div>
  </div>

  <div class="container" *ngIf="!isDataLoading && !sessionInfo">
    <div class="card p-2 py-1 m-2 border-0 shadow py-5">
      <!-- DOTTED CARD -->
      <div class="dotted-card">
        <!-- ILLUSTRATION -->
        <div class="illustration">
          <div class="ping-container">
            <div class="ping"></div>
            <div class="clock-wrapper">
              <img
                src="assets\images\hourglass.png"
                alt="Session Expired Illustration"
                style="width: 150px; height: 150px; object-fit: contain"
              />
            </div>

            <div class="emoji-one">
              <img src="assets\images\clock.png" alt="" />
            </div>

            <div class="emoji-two">
              <img src="assets\images\sad.png" alt="" />
            </div>
          </div>
        </div>

        <!-- TEXT SECTION -->
        <!-- <div class="dotted-content">
            <h1 class="title">Oops! Session Expired</h1>

            <p class="desc">
              We're sorry, but your document upload session has expired. Upload
              sessions remain active only for
              <strong style="color: #c10260">24 hours</strong>.
            </p>
          </div> -->

        <div class="dotted-content">
          <h1 class="title">Upload Session Closed</h1>

          <p class="desc">
            Your document upload session has been closed. This can happen once a
            document is submitted, or automatically if the session expires after
            <strong style="color: #c10260">24 hours</strong>.
          </p>
        </div>
      </div>

      <!-- ILLUSTRATION -->
      <!-- <div class="illustration">
                <div class="ping-container">
                    <div class="ping"></div>
                    <div class="clock-wrapper">
                        <img src="/images/hourglass.png" alt="Session Expired Illustration"
                            style="width:150px; height:150px; object-fit:contain;">
                    </div>

                    <div class="emoji-one">
                        <img src="/images/clock.png" alt="">
                    </div>

                    <div class="emoji-two">
                        <img src="/images/sad.png" alt="">
                    </div>


                </div>
            </div> -->

      <!-- CONTENT -->
      <div class="text-center">
        <!-- <h1 class="title">Oops! Session Expired</h1>

                <p class="desc">
                    We're sorry, but your document upload session has expired.
                    Upload sessions remain active only for <strong style="color: #C10260;">24 hours</strong>.
                </p> -->

        <div class="info-box fw-semibold p-3">
          Don’t worry! This is for security purposes. If you were not able to
          upload your document, please contact our support team and we’ll send
          you a fresh upload link.
        </div>

        <h2 class="gradient-underline mb-2">Get a New Upload Session</h2>

        <!-- CONTACT CARDS -->
        <div class="cards">
          <!-- EMAIL -->
          <div class="contact-card border-0 p-2">
            <div
              class="icon-circle mb-3 d-flex justify-content-center align-items-center"
            >
              <img
                src="assets\images\mail.png"
                alt="Email Icon"
                style="width: 50px; height: 50px"
              />
            </div>
            <h3 class="fw-semibold mb-2">Email Us</h3>
            <a
              href="mailto:nishwikdev@gmail.com"
              class="fw-semibold fs-6 text-decoration-none"
            >
              support@nishwik.com
            </a>
            <p class="fw-semibold text-muted mt-2 small">
              Response within 2–4 hours
            </p>
          </div>

          <!-- PHONE -->
          <div class="contact-card border-0 p-2">
            <div
              class="icon-circle mb-3 d-flex justify-content-center align-items-center"
            >
              <img
                src="assets\images\call.png"
                alt="Phone Icon"
                style="width: 50px; height: 50px"
              />
            </div>
            <h3 class="fw-semibold mb-2">Call Us</h3>
            <a
              href="tel:1800-123-6474"
              class="fw-semibold fs-6 text-decoration-none"
            >
              9699783260
            </a>
            <p class="fw-semibold text-muted mt-2 small">
              Mon–Sat, 9 AM – 6 PM
            </p>
          </div>
        </div>

        <div class="list-box">
          <div class="list-box-header">
            <i data-lucide="clipboard-list" class="list-icon"></i>
            <h3>What to Include in Your Request</h3>
          </div>

          <ul class="list-content">
            <li>Your Society name & registration number</li>
            <li>Contact person name & designation</li>
            <li>Registered email & phone number</li>
            <li>Mention “New Upload Session Request”</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- NEW -->

<!-- Success Popper Modal -->
<div
  class="modal fade"
  id="successPopper"
  tabindex="-1"
  aria-hidden="true"
  data-bs-backdrop="false"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content glass-morphism p-4 position-relative">
      <!-- Close Button -->
      <button
        type="button"
        class="btn-close position-absolute top-0 end-0 m-3"
        data-bs-dismiss="modal"
      ></button>

      <div class="modal-body text-center">
        <!-- Success Icon -->
        <div
          class="icon-circle1 d-flex justify-content-center align-items-center mx-auto mb-4"
          (click)="refreshPage()"
        >
          <i class="fa-solid fa-circle-check fa-3x text-white"></i>
        </div>

        <h3 class="fw-bold mb-3">Upload Successful!</h3>

        <p class="text-dark mb-2" style="font-weight: 700">
          You have successfully uploaded your document. The Nishwik team will
          now review and verify your document within 24–48 hours.
        </p>

        <p class="text-secondary" style="font-weight: 500">
          Thanks for binding with Nishwik! We hope you have uploaded all the
          required documents properly.
        </p>

        <!-- Done Button -->
        <div class="mt-4">
          <button
            class="universal-submit-btn"
            data-bs-dismiss="modal"
            (click)="refreshPage()"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-chat-bot
  *ngIf="societyInfo"
  [societyInfo]="societyInfo"
  window="document-upload"
></app-chat-bot>
